import angular from 'angular';
import toolbarComponent from './app-toolbar.component';
import './app-toolbar.scss';

export default angular.module('common.app-toolbar', [])
  .component('appToolbar', toolbarComponent)
  .name;



// WEBPACK FOOTER //
// ./components/app/common/app-toolbar/app-toolbar.module.js